import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    iconSlot: ReactNode;
    titleSlot: ReactNode;
    descriptionSlot: ReactNode;
}

export const AuthModalBenefitDescriptionBulletItem = ({iconSlot, titleSlot, descriptionSlot}: IProps) => {
    return (
        <div className={bulletItemWrapperStyle}>
            <div className={bulletItemIconWrapperStyle}>{iconSlot}</div>
            <div>
                <Text variant="headline_4" mb={1}>
                    {titleSlot}
                </Text>
                <Text variant="body_copy_2">{descriptionSlot}</Text>
            </div>
        </div>
    );
};

const bulletItemWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    columnGap: 2
});

const bulletItemIconWrapperStyle = css({
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "5.6rem",
    height: "5.6rem"
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    iconSlot: ReactNode;
    titleSlot: ReactNode;
    descriptionSlot: ReactNode;
}

export const AuthModalBenefitDescriptionBulletItem = ({iconSlot, titleSlot, descriptionSlot}: IProps) => {
    return (
        <div className={bulletItemWrapperStyle}>
            <div className={bulletItemIconWrapperStyle}>{iconSlot}</div>
            <div>
                <Text variant="headline_4" mb={1}>
                    {titleSlot}
                </Text>
                <Text variant="body_copy_2">{descriptionSlot}</Text>
            </div>
        </div>
    );
};

const bulletItemWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    columnGap: 2
});

const bulletItemIconWrapperStyle = css({
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "5.6rem",
    height: "5.6rem"
});
